import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


const AIQ_SCORE_PARAMS = [
  { id: 'score_plays_engagement',       name: '再生率スコア',            help: '(リール再生数 ÷ フォロワー数)によるスコア付けになります' },
  { id: 'score_follower_trends_month',  name: 'フォロワー上昇率(1ヶ月)', help: '現在から1ヶ月間のフォロワー数の上昇率によるスコア付けになります' },
  { id: 'score_follower_trends_month3', name: 'フォロワー上昇率(3ヶ月)', help: '現在から3ヶ月間のフォロワー数の上昇率によるスコア付けになります' },
  { id: 'score_follower_trends_month6', name: 'フォロワー上昇率(6ヶ月)', help: '現在から6ヶ月間のフォロワー数の上昇率によるスコア付けになります' },
  { id: 'score_interval',               name: '投稿間隔スコア',          help: '投稿間隔が短いほどスコアが上がります' },
  { id: 'score_assign',                 name: 'アサイン実績スコア',      help: 'アサイン回数によるスコア付けになります（NGの回数でスコアが減ります）' },
  { id: 'score_wordcloud',              name: 'ワードクラウドスコア',    help: '自身のワードクラウドとフォロワーのワードクラウドの一致度によるスコア付けになります' },
];

class InfluencerBasis extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    if( data.score == undefined ) data.score = {};
    
    if( data.is_guest === true ) return null;
    
    let score_sum = 0;
    AIQ_SCORE_PARAMS.map((d, key) => { if( data.score[d.id] != undefined ) score_sum += data.score[d.id]; });
    
    return (
      <div className="recommend-score">
        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>スコアの詳細を表示</Tooltip>}>
          <div className="recommend-item" onClick={this.toggleModal.bind(this)}>
            <h5>AIQスコア</h5>
            <h3>{Utils.viewInt(data.score.recommend)}</h3>
          </div>
        </OverlayTrigger>
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {'calc(100% - 150px)'}
          height    = {'calc(100% - 180px)'}
          max_width = {400}
          close_ev  = {this.toggleModal.bind(this)}
          html      = {
            <div className="modal-item recommend-score-detail">
              <h2>AIQスコア詳細</h2>
              
              <div className="score-result">
                <div className="score-item">
                  <h6>スコア合計</h6>
                  <h2>{Utils.viewInt(score_sum)}<span>pt</span></h2>
                </div>
                <h1>×</h1>
                <div className="score-item">
                  <h6>フォロワー数倍率<OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>フォロワー数が多いほど最終スコアの倍率が減ります。（アサインが現実的なユーザーを絞り込むため）</Tooltip>}><i className="material-icons">help</i></OverlayTrigger></h6>
                  <h2>{Utils.viewInt(data.score.score_cap_rate)}%</h2>
                </div>
                <h1>＝</h1>
                <div className="score-item fix-score">
                  <h6>AIQスコア</h6>
                  <h2>{Utils.viewInt(data.score.recommend)}<span>pt</span></h2>
                </div>
              </div>
              
              <ul>
                { AIQ_SCORE_PARAMS.map((d, key) => {
                  let score = data.score[d.id];
                  return (
                    <li key={key}>
                      <h4>{d.name}<OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>{d.help}</Tooltip>}><i className="material-icons">help</i></OverlayTrigger></h4>
                      <h3><i>…</i>{Utils.viewInt(score)}<span>pt</span></h3>
                    </li>
                  );
                })}
              </ul>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerBasis;